var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHospitalLogo = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 38,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0FAFB",
  d: "M0 0h38v38H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6FBFC",
  d: "M24 0h14v38H25l1-2c.225-1.537.408-3.08.563-4.625L27 27l10-1-1-13h-1v11l-11 1v9H14c-.86-11.808-.86-11.808 2.188-15.75C19 16 19 16 21.813 15.625L24 16c-.812 3.438-.812 3.438-2 7l-3 1c3.123-.486 5.996-.999 9-2l2-14-3.5 1.938C22.276 12.072 18.698 12.664 14 13V3h11z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6A8FB9",
  d: "M0 0c3.958-.058 7.916-.094 11.875-.125l3.418-.05 3.262-.02 3.015-.032C24 0 24 0 26 2c.125 3.125.125 3.125 0 6h-1V3H14l1 9 4.313-.875 2.425-.492C24.253 10.055 24.253 10.055 27 8h3q.079 2.374.125 4.75l.07 2.672c-.208 2.751-.69 4.282-2.195 6.578-3.777 2.35-6.55 3.393-11 3 2-2 2-2 5.063-3.25 3.26-1.482 3.26-1.482 3.812-4.937L26 14l-2 1c-2.037.229-4.08.41-6.125.563l-3.32.253L12 16l-1 5c-1.125-3.75-1.125-3.75 0-6l-8-1v11h5v1H2C.408 22.482-.243 19.773-.195 15.918l.02-2.822.05-2.908.027-2.967Q-.062 3.61 0 0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#678CB5",
  d: "m33 12 4 1v13c-3.215 1.607-6.436 1.057-10 1l.07 1.898.055 2.477.07 2.46C27 36 27 36 25 38c-2.75.266-2.75.266-6 .25l-3.25.016C13 38 13 38 11 36c-.266-2.68-.266-2.68-.25-5.875l-.016-3.18c.262-2.9.644-4.55 2.266-6.945 2.625-1.25 2.625-1.25 5-2l-1.457 1.61c-1.927 2.985-2.039 5.114-2.23 8.64-.1 1.616-.1 1.616-.2 3.266L14 34h10v-9c3.43-1.715 7.217-1.054 11-1V13z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#97BDBA",
  d: "M30 8q.079 2.374.125 4.75l.07 2.672c-.208 2.751-.69 4.282-2.195 6.578-3.777 2.35-6.55 3.393-11 3 2-2 2-2 5.063-3.25 3.26-1.482 3.26-1.482 3.812-4.937L26 14l-2 1c-2.037.229-4.08.41-6.125.563l-3.32.253L12 16l-1 5c-.981-3.053-.981-4.947 0-8 3.603-.927 7.232-1.67 10.879-2.402C25.13 9.682 26.467 8 30 8"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8FCF7",
  d: "M0 0h13l-2 1c-.467 2.126-.467 2.126-.625 4.563l-.227 2.503L10 10l-1.934.148-2.504.227c-.823.07-1.647.14-2.496.21L1 11l-1 2z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F1F9FD",
  d: "M3 14h9l-1.562 6.836C9.934 22.959 9.934 22.959 10 25H3z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#77A0C7",
  d: "m18.563-.312 2.94.011C24 0 24 0 26 2c.125 3.125.125 3.125 0 6h-1V3q-2.72.172-5.437.375c-1.01.07-2.02.14-3.06.21-.825.138-1.652.274-2.503.415l-1 2h-2v6l-8-1v-1h7l-.187-3.312C10 3 10 3 11.164 1.289c2.533-1.778 4.33-1.655 7.399-1.601"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#7D9ABE",
  d: "m16 18 2 1-1.457 1.113c-2.155 2.635-2.05 4.712-2.23 8.075l-.2 3.292L14 34h10v1l-2.336-.035-3.039-.028-3.023-.035C13.016 34.82 13.016 34.82 11 36a498 498 0 0 1-.125-5.75l-.07-3.234c.194-2.997.523-4.557 2.195-7.016z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#DBF1FC",
  d: "M37 27c-2.36 2.36-3.779 2.491-7 3l.563 2.313C31 35 31 35 30 38h-5l1-2c.225-1.537.408-3.08.563-4.625l.253-2.477L27 27c7.75-1.125 7.75-1.125 10 0"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#A0C7BD",
  d: "M25 13h2v4h2l1-2c-.33 2.965-.849 4.783-2.562 7.25C23.978 24.734 21.223 24.718 17 25c2.41-2.41 4.943-3.538 8-5z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#8BC2B9",
  d: "M27 8h3c.125 6.75.125 6.75-1 9h-2v-4h-2c.875-3.875.875-3.875 2-5"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#5B88BA",
  d: "M13 4h1c.098 6.152.098 6.152 0 8-1 1-1 1-4.562 1.063L6 13v-2l5 1V6h2z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9F2FB",
  d: "m28 20 2 4-6 1v9h-1l-1-10 6-2z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#E3F8FB",
  d: "M14 3h4v2h-2v5l6 1v1l-8 1z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#8CA6B9",
  d: "m16 18 2 1-1.437 1c-2.42 3.098-2.245 6.12-2.563 10l-3-2c.432-4.752 1.328-6.92 5-10"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#A2C8C4",
  d: "M18 13c-3.75 3-3.75 3-6 3l-1 5c-.971-3.021-1.136-5.005 0-8 2.667-1.333 4.167-.671 7 0"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#E3FAFA",
  d: "M22 3h3v5l2 1-5 2 .563-2.312C23.228 5.91 23.228 5.91 22 3"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#E1EFF1",
  d: "M17.125 15.938c.949.35 1.898.7 2.875 1.062l-6 3v-3l-2-1c2-1 2-1 5.125-.062"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#E9FBFD",
  d: "M9 0c2.125.375 2.125.375 4 1h-2l-1 5H8c-.625-1.875-.625-1.875-1-4z"
})));
export { SvgHospitalLogo as ReactComponent };
export default __webpack_public_path__ + "assets/images/hospital-logo.svg";